import { getFamilyIds } from '@editor2/services/storeService';
import { ChangesStatus } from '@editor2/types/changesStatus';
import { type Chapter } from '@editor2/types/chapter';
import { type CourseState } from '@editor2/types/courseState';
import { NgTraditional } from '@editor2/types/ngTraditional';

import { getDeletedModifiedConflict } from '../helpers/createConflictHelper';
import { getUpdatedValuesAndConflicts } from '../helpers/detectConflictHelper';

export class ChapterConflictDetector {
	detectConflicts = (state: CourseState, node) => {
		const { family_id, pages, page_groups, ...chapter } = node as Chapter;

		const chapterChildren = {
			...(chapter.page_groups_enabled && { page_groups: getFamilyIds(page_groups) }),
			...(!chapter.page_groups_enabled && { pages: getFamilyIds(pages) })
		};

		// if current is deleted but incoming is modified
		if (state.changes.chapters[family_id]?.includes(ChangesStatus.Deleted)) {
			const conflict = getDeletedModifiedConflict({
				attribute: 'chapters',
				entityType: NgTraditional.Chapter,
				id: family_id,
				state,
				incoming: { ...chapter, ...chapterChildren, family_id }
			});

			state.conflicts = [...state.conflicts, conflict];
			return;
		}

		const initial = state.initialCourse.chapters.entities[family_id];
		const current = state.chapters.entities[family_id];
		const incoming = { family_id, ...chapter, ...chapterChildren };
		const attributes = { ...chapter, ...chapterChildren };

		const payload = { initial, current, incoming, attributes, state };

		const data = getUpdatedValuesAndConflicts(payload);
		return data;
	};

	applyDiffToInitial = ({ state, family_id, updatedInitial }) => {
		state.initialCourse.chapters.entities[family_id] = { family_id, ...updatedInitial };
	};

	applyDiffToCurrent = ({ state, family_id, updatedCurrent }) => {
		state.chapters.entities[family_id] = { family_id, ...updatedCurrent };
	};

	applyConflict = ({ state, conflicts }) => {
		state.conflicts = [...state.conflicts, ...conflicts];
	};
}
